export interface MetaProps extends MetaLogoConfig {
    title: string;
    className?: string;
    /** Default: 2 */
    titleLines?: number;
    subTitle?: string;
    isNeedPlaceholder?: boolean;
    mode?: MetaMode;
    subTitleViewVariant?: SubTitleViewVariant;
    editorAnnotation?: string;
}

export enum MetaMode {
    DEFAULT = 'default',
    USER_VOTE = 'user-vote',
}

type MetaLogoConfig = {
    logoUrl?: string;
    logoWidth?: number;
    logoHeight?: number;
};

export enum SubTitleViewVariant {
    Regular,
    Medium,
}
